import { BookingType } from "../../../features/Booking-Form/typings/booking-inputs";
import { BookingScheduleInterface } from "../../../features/Booking-Form/typings/booking.types";

/** Conference schedule row carries room visitor registrations on `visitorBookings` or external `guests`. */
export function conferenceRoomHasVisitorRegistrations(
  schedule: Pick<BookingScheduleInterface, "bookingType" | "guests" | "visitorBookings">
): boolean {
  if (schedule.bookingType !== BookingType.CONFERENCEZONE) {
    return false;
  }

  if ((schedule.visitorBookings?.length ?? 0) > 0) {
    return true;
  }

  return schedule.guests?.some(guest => guest.external) ?? false;
}
